import { TUNNEL_SERVICE_KEY } from './tunnelEnum.js';
import createPusherEventHandlersForService from 'shared/clients/pusher/createPusherEventHandlersForService.js';

export default createPusherEventHandlersForService(TUNNEL_SERVICE_KEY);
